module.exports = __webpack_public_path__ + "static/media/browser.4795728c.cjs";